"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlockId = (block) => {
    return block.id || block.clientId;
};
//# sourceMappingURL=getBlockId.js.map